export const container = "c9uidwh";
export const avatar = "azyjt2l";
export const testimonial = "t1qey2zl";
export const divider = "d15p6psy";
export const imageContainer = "i1aaum8g";
export const image = "ie02i4s";

require("./styles.linaria.module.css!=!../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");